<script setup lang="ts">
import type { AsyncDataRequestStatus } from '#app'
import type { ProductSmartFilter } from '~/types/api'

const props = defineProps<{
  smartFilters: ProductSmartFilter[]
  status: AsyncDataRequestStatus
}>()

const { getResourceUrl, getImageSrcSet } = useResources()
const localePath = useLocalePath()
</script>

<template>
  <div class="grid gap-5 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
    <NuxtLink
      v-for="smartFilter in props.smartFilters"
      :key="smartFilter.nid"
      :to="
        localePath({
          name: 'products-slug',
          params: { slug: smartFilter.urlSlug },
        })
      "
      class="flex items-center gap-2 bg-neutral-100 p-3 no-underline"
    >
      <NuxtImg
        v-if="smartFilter.icon"
        :src="withHost(smartFilter.icon.url)"
        class="h-6 w-6"
        alt=""
      />
      <p class="text-sm font-bold">
        {{ smartFilter.title }}
      </p>
    </NuxtLink>
  </div>
</template>
